export const MuiInputLabel = {
  styleOverrides: {
    root: {
      color: '#a8aeb8',
    },
  },
};
